(function(){
  var root=(window.themeRoutes&&window.themeRoutes.root)||'/';
  if(root.slice(-1)!=='/')root+='/';
  /* mobile nav */
  var toggle=document.querySelector('[data-nav-toggle]');
  if(toggle){toggle.addEventListener('click',function(){var o=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!o));document.body.classList.toggle('nav-open',!o);});}

  /* slideshow */
  document.querySelectorAll('[data-slideshow]').forEach(function(el){
    var slides=el.querySelectorAll('[data-slide]'),dots=el.querySelectorAll('[data-dot]'),i=0,timer;
    if(slides.length<2)return;
    function go(n){i=(n+slides.length)%slides.length;slides.forEach(function(s,k){s.classList.toggle('is-active',k===i);});dots.forEach(function(d,k){d.classList.toggle('is-active',k===i);});}
    function start(){if(el.dataset.autoplay!=='true'||(window.Shopify&&Shopify.designMode))return;clearInterval(timer);timer=setInterval(function(){go(i+1);},(parseInt(el.dataset.interval,10)||6)*1000);}
    dots.forEach(function(d){d.addEventListener('click',function(){go(+d.dataset.dot);start();});});
    var p=el.querySelector('[data-prev]'),n=el.querySelector('[data-next]');
    if(p)p.addEventListener('click',function(){go(i-1);start();});
    if(n)n.addEventListener('click',function(){go(i+1);start();});
    document.addEventListener('shopify:block:select',function(e){var idx=[].indexOf.call(slides,e.target);if(idx>-1)go(idx);});
    start();
  });

  /* product tabs */
  document.querySelectorAll('[data-tabs]').forEach(function(el){
    var btns=el.querySelectorAll('[data-tab-btn]'),panels=el.querySelectorAll('[data-tab-panel]');
    btns.forEach(function(b){b.addEventListener('click',function(){btns.forEach(function(x){x.classList.toggle('is-active',x===b);});panels.forEach(function(p){p.hidden=p.dataset.tabPanel!==b.dataset.tabBtn;});});});
  });

  /* countdown */
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var t=new Date(el.dataset.countdown).getTime();
    function tick(){var d=Math.max(0,t-Date.now());var days=Math.floor(d/864e5);d-=days*864e5;var h=Math.floor(d/36e5);d-=h*36e5;var m=Math.floor(d/6e4);
      el.querySelector('[data-cd="d"]').textContent=days;el.querySelector('[data-cd="h"]').textContent=h;el.querySelector('[data-cd="m"]').textContent=m;}
    if(!isNaN(t)){tick();setInterval(tick,30000);}
  });

  /* cart drawer */
  function drawer(){return document.querySelector('[data-cart-drawer]');}
  function openCart(){var d=drawer();if(!d)return false;d.hidden=false;document.documentElement.classList.add('popup-open');return true;}
  function closeCart(){var d=drawer();if(d){d.hidden=true;document.documentElement.classList.remove('popup-open');}}
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-cart-open]');
    if(o&&document.body.className.indexOf('template-cart')===-1&&drawer()){e.preventDefault();openCart();return;}
    if(e.target.closest('[data-cart-close]')){e.preventDefault();closeCart();}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});
  function refresh(){
    return fetch(root+'?sections=cart-drawer').then(function(r){return r.json();}).then(function(j){
      var wrap=document.getElementById('shopify-section-cart-drawer');
      if(wrap&&j['cart-drawer']){var doc=new DOMParser().parseFromString(j['cart-drawer'],'text/html');var inner=doc.getElementById('shopify-section-cart-drawer');wrap.innerHTML=inner?inner.innerHTML:j['cart-drawer'];}
      var src=document.querySelector('[data-cart-count-source]');
      if(src)document.querySelectorAll('[data-cart-count]').forEach(function(c){c.textContent=src.textContent;});
    });
  }
  document.addEventListener('submit',function(e){
    var f=e.target.closest('[data-quick-add]');if(!f)return;
    e.preventDefault();var btn=f.querySelector('button');if(btn){btn.disabled=true;btn.dataset.label=btn.textContent;btn.textContent='Adding…';}
    fetch(root+'cart/add.js',{method:'POST',body:new FormData(f),headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw r;return refresh();})
      .then(function(){openCart();})
      .catch(function(){f.submit();})
      .finally(function(){if(btn){btn.disabled=false;btn.textContent=btn.dataset.label;}});
  });

  /* popup */
  var popup=document.querySelector('[data-popup]');
  var launcher=document.querySelector('.popup-launcher');
  if(!popup)return;
  var KEY='smiths-popup-dismissed';
  function open(){popup.hidden=false;document.documentElement.classList.add('popup-open');if(launcher)launcher.hidden=true;}
  function close(){popup.hidden=true;document.documentElement.classList.remove('popup-open');try{sessionStorage.setItem(KEY,'1');}catch(e){}if(launcher)launcher.hidden=false;}
  popup.querySelectorAll('[data-popup-close]').forEach(function(el){el.addEventListener('click',function(e){if(el.tagName!=='A')e.preventDefault();close();});});
  document.querySelectorAll('[data-open-popup]').forEach(function(el){el.addEventListener('click',function(e){e.preventDefault();open();});});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!popup.hidden)close();});
  var dismissed=false;try{dismissed=sessionStorage.getItem(KEY)==='1';}catch(e){}
  var once=popup.getAttribute('data-once')==='true';
  if(popup.querySelector('[data-popup-success]')){open();return;}
  if(window.Shopify&&Shopify.designMode){if(launcher)launcher.hidden=false;document.addEventListener('shopify:section:select',function(e){if(e.target.contains(popup))open();});document.addEventListener('shopify:section:deselect',function(e){if(e.target.contains(popup))close();});return;}
  if(once&&dismissed){if(launcher)launcher.hidden=false;return;}
  setTimeout(open,(parseInt(popup.getAttribute('data-delay'),10)||0)*1000);
})();
